module.exports = __webpack_public_path__ + "static/media/green-popsicle.1d856830.png";